<template>
    <section class="colorlib-blog" data-section="blog">
        <div class="colorlib-narrow-content">
            <div class="row">
                <div class="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                    <span class="heading-meta">Read</span>
                    <h2 class="colorlib-heading">Recent Blog</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-6 animate-box" data-animate-effect="fadeInLeft">
                    <div class="blog-entry services">
                        <a href="https://qr-menu.uz/" class="blog-img"><img src="images/landingPage.png" class="img-responsive" alt="HTML5 Bootstrap Template by colorlib.com"></a>
                        <div class="desc">
                            <span><small>April 14, 2022 </small> | <small> Landing Page </small> </span>
                            <h3><a href="https://qr-menu.uz/">Landing Page</a></h3>
                            <p></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 animate-box" data-animate-effect="fadeInRight">
                    <div class="blog-entry services">
                        <a href="https://library.tiiame.uz/en" class="blog-img"><img src="images/electronicLibrary.png" class="img-responsive" alt="HTML5 Bootstrap Template by colorlib.com"></a>
                        <div class="desc">
                            <span><small>May,  2021</small> | <small> Library </small></span>
                            <h3><a href="https://library.tiiame.uz/en">Electronic Library</a></h3>
                            <p>This is an online library, In this Library, you can search for books that you need and be able to read an online book or just download it </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 animate-box" data-animate-effect="fadeInLeft">
                    <div class="blog-entry services">
                        <a href="https://vuesarawak.netlify.app/" class="blog-img"><img src="images/form.png" class="img-responsive" alt="HTML5 Bootstrap Template by colorlib.com"></a>
                        <div class="desc">
                            <span><small>August, 2021 </small> | <small> Form </small></span>
                            <h3><a href="https://vuesarawak.netlify.app/">Form for Employee</a></h3>
                            <p>This form is made for enrolling online for the company, to apply for the company Employee firstly has to create an account or have to login back existing account, after that fill out the form then Employee submits it if everything is okay, and there is admin panel in this project only admin can see this page and see employee form if the employee meets company demand, next admin approves the form.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 animate-box">
                    <p><a href="https://github.com/alisherOhunov" class="btn btn-primary btn-lg btn-load-more">Load more <i class="icon-reload"></i></a></p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default{
        // eslint-disable-next-line vue/multi-word-component-names
        name:"Blog"
    }
</script>